import Grid from '@mui/material/Grid';
import { default as Typography } from '@mui/material/Typography';
import { FieldErrorMessage } from './FieldErrorMessage';

interface Props {
  error: boolean;
  touched: boolean;
  name: string;
  valueLength: number;
  maxCharacterCount?: number;
}

const FieldMessage: React.FC<Props> = ({
  error,
  touched,
  name,
  valueLength,
  maxCharacterCount
}) => {
  const showCharacterCount = Boolean(maxCharacterCount);
  const showError = error && touched;

  return (
    <Grid
      container
      direction={showError && showCharacterCount ? 'row-reverse' : 'row'}
      justifyContent={
        showError && showCharacterCount ? 'space-between' : 'flex-end'
      }
      alignItems="center"
    >
      {showCharacterCount && (
        <Typography variant="body2">{`${valueLength}/${maxCharacterCount}`}</Typography>
      )}
      {showError && <FieldErrorMessage name={name} />}
    </Grid>
  );
};

export default FieldMessage;
